// A panel's tap gate (FarmMarket + gameUi.cardFeedback): a card's action runs a beat after its tap
// so the pop is seen; meanwhile no other card, Zamknij or the backdrop may act, and nothing runs
// once the panel is closed.
export function tapGate() {
  let busy = false, closed = false;
  return {
    begin() { if (busy || closed) return false; busy = true; return true; },
    end() { busy = false; },
    close() { closed = true; },
    get busy() { return busy; },
    get closed() { return closed; },
  };
}
